(() => {
  'use strict';

  const ROOT = '.selleasy-block-product-addon, .lb-addon-cont';
  const CARD = '.lb-upsell-product-page-card, .lb-product-card';
  const TOGGLE = 'codex-selleasy-toggle';
  const COLLAPSED = 'codex-selleasy-card-collapsed';
  const VISIBLE_COUNT = 3;
  const mountedRoots = new WeakSet();
  const CARD_STYLE_SELECTOR = [
    '.selleasy-block-product-addon .lb-upsell-product-page-card',
    '.selleasy-block-product-addon .lb-product-card',
    '.lb-addon-cont .lb-upsell-product-page-card',
    '.lb-addon-cont .lb-product-card',
  ].join(',');
  const COLLAPSED_STYLE_SELECTOR = [
    `.selleasy-block-product-addon .${COLLAPSED}`,
    `.lb-addon-cont .${COLLAPSED}`,
  ].join(',');

  const addTransitionStyle = () => {
    if (document.getElementById('codex-selleasy-transition-style')) return;
    const style = document.createElement('style');
    style.id = 'codex-selleasy-transition-style';
    style.textContent = `${CARD_STYLE_SELECTOR}{overflow:hidden;max-height:1000px;opacity:1;transition:max-height .28s ease,opacity .2s ease,margin .28s ease}${COLLAPSED_STYLE_SELECTOR}{max-height:0!important;opacity:0;pointer-events:none;margin-top:0!important;margin-bottom:0!important}`;
    document.head.appendChild(style);
  };

  const getCards = (root) => [...root.querySelectorAll(CARD)];

  const update = (root) => {
    const cards = getCards(root);
    let toggle = root.querySelector(`.${TOGGLE}`);

    if (cards.length <= VISIBLE_COUNT) {
      if (toggle) toggle.remove();
      cards.forEach((card) => {
        card.classList.remove(COLLAPSED);
      });
      return;
    }

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = TOGGLE;
      toggle.style.cssText = 'display:block;width:100%;padding:8px 0;border:0;background:transparent;color:#f83a3a;font-weight: 500;cursor:pointer;font:inherit;text-align:right;';
      toggle.dataset.expanded = 'false';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', () => {
        const nextExpanded = toggle.dataset.expanded !== 'true';
        toggle.dataset.expanded = String(nextExpanded);
        toggle.setAttribute('aria-expanded', String(nextExpanded));
        update(root);
      });
      root.appendChild(toggle);
    }

    const expanded = toggle.dataset.expanded === 'true';
    cards.forEach((card, index) => {
      card.classList.toggle(COLLAPSED, !expanded && index >= VISIBLE_COUNT);
    });
    const remaining = Math.max(0, cards.length - VISIBLE_COUNT);
    const label = expanded ? 'Show less' : `Show more (${remaining})`;
    if (toggle.textContent !== label) toggle.textContent = label;
  };

  const mount = (root) => {
    if (mountedRoots.has(root)) return;
    mountedRoots.add(root);

    let timer = 0;
    const schedule = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => update(root), 80);
    };

    update(root);
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
  };

  const start = () => {
    addTransitionStyle();
    const mountAll = () => document.querySelectorAll(ROOT).forEach(mount);
    mountAll();

    // Selleasy renders asynchronously and may replace its widget after a variant change.
    new MutationObserver(mountAll).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
